import * as Yup from 'yup';

export const eventValidationSchema = Yup.object().shape({
  title: Yup.string().required('Nome do evento é obrigatório'),
  start_date: Yup.string().required('Data de início é obrigatória'),
  end_date: Yup.string().required('Data de término é obrigatória'),
  start_time: Yup.string().nullable(),
  end_time: Yup.string().nullable(),
  overnight: Yup.boolean().nullable(),
  description: Yup.string().nullable(),
  hasTickets: Yup.boolean(),
  requireCheckIn: Yup.boolean(),
  observation: Yup.string().nullable(),
  image: Yup.string().nullable(),
  rules_for_children: Yup.string().nullable(),
  own_transport: Yup.boolean().nullable(),
  valor_ingresso_inteiro: Yup.number().required('Valor inteiro é obrigatório'),
  valor_ingresso_meia: Yup.number().required('Valor meia é obrigatório'),
  valor_ingresso_estudante: Yup.number().required('Valor estudante é obrigatório'),
  valor_ingresso_crianca: Yup.number().required('Valor criança é obrigatório'),
  organizer_id: Yup.string().required('Campo organizador é obrigatório'),
  status: Yup.string()
    .oneOf(['open', 'closed', 'cancelled'], 'Status inválido')
    .required('Status é obrigatório'),
  registration_deadline: Yup.string().nullable(),
  dynamicFields: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required('Label é obrigatório'),
      type: Yup.mixed<'text' | 'yes_no' | 'date' | 'number' | 'email' | 'phone' | 'select'>()
        .oneOf(['text', 'yes_no', 'date', 'number', 'email', 'phone', 'select'])
        .required('Tipo é obrigatório'),
      required: Yup.boolean().required('Obrigatoriedade é obrigatória'),
      options: Yup.array().when('type', {
        is: 'select',
        then: schema => schema.min(1, 'Informe pelo menos uma opção').required('Opções são obrigatórias'),
        otherwise: schema => schema.notRequired(),
      }),
    })
  ).optional(),
  gtm_container_id: Yup.string()
    .nullable()
    .test('gtm-format', 'Formato inválido. Use GTM-XXXXXXX', (value) => {
      if (!value || !value.trim()) {
        return true;
      }
      return /^GTM-[A-Z0-9]+$/i.test(value.trim());
    }),
});